export const COVERS_IMAGE =
  'https://cdn.magicpatterns.com/uploads/cwbKw5NcrWVB2UpZLxavGJ/2e109b46-f2d0-4d43-95d4-0e19a3324947.webp'

export const BUNDLE_IMAGE =
  'https://cdn.magicpatterns.com/uploads/cwbKw5NcrWVB2UpZLxavGJ/2e109b46-f2d0-4d43-95d4-0e19a3324947.webp'

export const FAMILY_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/ff4d5593-c80e-4b12-b01b-21924d181afb.jpg'

export const BRAND = 'Laboratorio del Giovane Inventore'
export const PRICE = '€ 19'
export const FULL_PRICE = '€ 49'
export const TOTAL_VALUE = '€ 149'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '6', label: 'Volumi passo-passo' },
  { value: '5', label: 'Bonus inclusi' },
  { value: '5–12', label: 'Età consigliata' },
  { value: PRICE, label: 'Offerta di lancio' },
]

export const heroChips: string[] = [
  '6 Volumi con guide passo-passo',
  '5 Bonus esclusivi inclusi',
  'Progetti e Sfide STEM',
  'Ideale dai 5 ai 12 anni',
  'Garanzia di 7 giorni',
]

export interface ContrastItem {
  text: string
}

export const beforeItems: ContrastItem[] = [
  {
    text: "Un altro pomeriggio finisce davanti a un video semplicemente perché non c'è un'alternativa pratica pronta all'uso.",
  },
  {
    text: 'Vuoi tagliare il tempo davanti allo schermo, ma non hai sempre un’attività che li entusiasmi davvero.',
  },
  {
    text: 'Salvi idee dai social, ma poi devi capire i materiali, i passaggi e come farli funzionare.',
  },
  {
    text: 'Molti kit intrattengono per un po’, ma tuo figlio finisce per seguire istruzioni fisse invece di pensare e creare.',
  },
]

export const afterItems: ContrastItem[] = [
  {
    text: 'Scegli i progetti per età, difficoltà, tempo e livello di aiuto necessario.',
  },
  {
    text: 'Usate cartone, tappi di bottiglia, cannucce, elastici e altri materiali di uso quotidiano.',
  },
  {
    text: 'Seguite istruzioni visive passo-passo per costruire robot, veicoli e meccanismi.',
  },
  {
    text: 'Scoprite cosa fa funzionare ogni invenzione con test, domande e spiegazioni semplici.',
  },
  {
    text: 'Si passa dal seguire i progetti al modificarli, migliorarli e infine progettare soluzioni originali.',
  },
]

export interface Situation {
  letter: string
  title: string
  description: string
}

export const situations: Situation[] = [
  {
    letter: 'A',
    title: 'Un altro pomeriggio davanti allo schermo',
    description:
      'Vuoi offrire qualcosa di diverso, ma tra lavoro e routine consegnare il telefono o il tablet diventa spesso l’opzione più semplice.',
  },
  {
    letter: 'B',
    title: 'La ricerca infinita di idee',
    description:
      'Trovi un robot di cartone fantastico, ma mancano dei passaggi, non sei sicuro che sia troppo difficile o servono materiali che non hai.',
  },
  {
    letter: 'C',
    title: 'Il kit che finisce in un cassetto',
    description:
      'Compri qualcosa di "educativo", lo montate una volta seguendo istruzioni fisse e poi viene riposto perché non c’è più nulla da scoprire.',
  },
  {
    letter: 'D',
    title: 'L’attività che intrattiene ma non insegna',
    description:
      'Costruite qualcosa di divertente, ma si perde la parte più preziosa: chiedersi perché funziona, cosa è fallito e come migliorarlo.',
  },
]

export interface Pillar {
  number: string
  title: string
  description: string
}

export const pillars: Pillar[] = [
  {
    number: '01',
    title: 'Fondamenta dell’Inventore',
    description:
      'Osservazione, stabilità, equilibrio, giunti e prime costruzioni.',
  },
  {
    number: '02',
    title: 'Robot e Creature Mobili',
    description:
      'Piattaforme semoventi, articolazioni e meccanismi che danno vita alle creazioni.',
  },
  {
    number: '03',
    title: 'Veicoli e Macchine in Movimento',
    description:
      'Ruote, assi, frizione e sterzo applicati a veicoli che corrono davvero.',
  },
  {
    number: '04',
    title: 'Macchine e Meccanismi',
    description:
      'Leve, pulegge, manovelle e come la forza cambia direzione.',
  },
  {
    number: '05',
    title: 'Esperimenti STEM e Ingegneria',
    description:
      'Resistenza, strutture e risoluzione di problemi attraverso missioni pratiche.',
  },
  {
    number: '06',
    title: 'Progetta, Testa e Inventa',
    description:
      'Schizzi, prototipi e invenzioni originali per smettere di seguire i passaggi e iniziare a creare.',
  },
]

export interface Volume {
  number: string
  title: string
  subtitle: string
  description: string
  cover: string
  points: string[]
}

export const volumes: Volume[] = [
  {
    number: 'Volume 01',
    title: 'Fondamenta dell’Inventore',
    subtitle: 'Le prime costruzioni e le buone abitudini',
    description:
      'Osservazione, stabilità, equilibrio, giunti e materiali di uso quotidiano: la base di tutto ciò che verrà dopo.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/c1c586cd-08e8-4793-b415-313e31eab13a.jpg',
    points: ['Osservazione', 'Stabilità', 'Equilibrio', 'Giunti'],
  },
  {
    number: 'Volume 02',
    title: 'Robot e Creature Mobili',
    subtitle: 'Corpi che si muovono, camminano e afferrano',
    description:
      'Articolazioni, perni, parti mobili e comandi manuali per costruire robot e creature con un movimento visibile e comprensibile.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/b99a0e88-b681-4a72-9524-5e719d122c82.jpg',
    points: ['Articolazioni', 'Perni', 'Parti mobili', 'Comandi manuali'],
  },
  {
    number: 'Volume 03',
    title: 'Veicoli e Macchine in Movimento',
    subtitle: 'Tutto ciò che rotola, corre e sterza',
    description:
      'Ruote, assi, frizione, direzione e stabilità applicati a veicoli e macchine che rotolano, corrono e reagiscono ai test.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/7d0f12b9-3e54-4eb7-ab5b-492822d8cacb.jpg',
    points: ['Ruote', 'Assi', 'Frizione', 'Sterzo'],
  },
  {
    number: 'Volume 04',
    title: 'Macchine e Meccanismi',
    subtitle: 'Sollevare, tirare e trasmettere la forza',
    description:
      'Leve, pulegge, manovelle e trasmissione del movimento per scoprire come le macchine sollevano, girano e trasformano la forza.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/ebe15442-2683-4fb2-8413-4dff3c6b8bb2.jpg',
    points: ['Leve', 'Pulegge', 'Manovelle', 'Trasmissione'],
  },
  {
    number: 'Volume 05',
    title: 'Esperimenti STEM e Ingegneria',
    subtitle: 'Strutture messe alla prova davvero',
    description:
      'Resistenza, strutture, test e problem-solving con sfide pratiche che li spingono a osservare, confrontare e migliorare.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/510d66b8-1d92-49bb-be29-76312008c2c0.jpg',
    points: ['Resistenza', 'Strutture', 'Test', 'Problem-solving'],
  },
  {
    number: 'Volume 06',
    title: 'Progetta, Testa e Inventa',
    subtitle: 'Dallo schizzo al prototipo finito',
    description:
      'Schizzi, prototipi, migliorie e invenzioni originali, per smettere di seguire i progetti e iniziare a creare i propri.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/28664d9e-4376-4c78-9490-e6e757a829f5.jpg',
    points: ['Schizzi', 'Prototipi', 'Migliorie', 'Invenzione originale'],
  },
]

export interface Stage {
  label: string
  title: string
  description: string
  tone: 'moss' | 'ink' | 'orange'
}

export const stages: Stage[] = [
  {
    label: 'Primo passo',
    title: 'Costruire',
    description:
      'Seguono istruzioni visive passo-passo e finiscono con qualcosa che funziona davvero tra le mani.',
    tone: 'moss',
  },
  {
    label: 'Secondo passo',
    title: 'Capire',
    description:
      'Ogni progetto spiega perché il meccanismo si comporta così, con test e domande semplici da rispondere insieme.',
    tone: 'ink',
  },
  {
    label: 'Terzo passo',
    title: 'Inventare',
    description:
      'Poi la guida si fa da parte: cambiano un pezzo, provano di nuovo e il progetto diventa finalmente loro.',
    tone: 'orange',
  },
]

export interface ProjectExample {
  image: string
  label: string
  title: string
  concept: string
}

export const projectExamples: ProjectExample[] = [
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5bb0164d-76c2-4080-9e11-cca0f0a86cb0.jpg',
    label: 'Volume 04',
    title: 'Il braccio che solleva',
    concept: 'Leve e forza',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ff6f3a90-155d-45a2-b6bd-fd484133c219.jpg',
    label: 'Volume 05',
    title: 'Il ponte di cannucce',
    concept: 'Struttura e carico',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/98bbdf26-5354-4999-98bc-df77790db0db.jpg',
    label: 'Volume 04',
    title: 'La puleggia con il rocchetto',
    concept: 'Sollevare girando',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d2eba7ce-fd20-4a44-8a3a-2c26213f1aeb.jpg',
    label: 'Volume 02',
    title: 'Il braccio con ingranaggi',
    concept: 'Cambiare direzione',
  },
]

export interface Bonus {
  label: string
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    label: 'Bonus 01',
    title: 'Guida ai Materiali Domestici',
    description:
      'Cosa conservare dal riciclo e come organizzare la vostra stazione creativa.',
  },
  {
    label: 'Bonus 02',
    title: 'Costruzioni Rapide da 15 Minuti',
    description: 'Missioni brevi per i giorni in cui il tempo è poco.',
  },
  {
    label: 'Bonus 03',
    title: 'Guida per Genitori "Costruire Insieme"',
    description: 'Come aiutare senza sostituirsi al bambino.',
  },
  {
    label: 'Bonus 04',
    title: 'Missioni di Ingegneria all’Aperto',
    description: 'Sfide da testare nel giardino o al parco.',
  },
  {
    label: 'Bonus 05',
    title: 'Kit dei Traguardi e Template',
    description: 'Schede tecniche e diplomi per celebrare ogni successo.',
  },
]

export interface Outcome {
  title: string
  description: string
}

export const outcomes: Outcome[] = [
  {
    title: 'Meno tempo davanti allo schermo',
    description:
      'Sostituisci i video con progetti che possono toccare con le mani.',
  },
  {
    title: 'Creatività + logica',
    description:
      'Scoprono perché una ruota gira o perché una struttura regge il peso.',
  },
  {
    title: 'Persistenza',
    description:
      'Se non funziona, osservano, cambiano una cosa sola e riprovano.',
  },
  {
    title: 'Tempo in famiglia',
    description:
      'Progetti chiari da godersi insieme, anche senza alcuna esperienza tecnica.',
  },
]

export const offerIncluded: string[] = [
  'Fondamenta per costruire, unire, muovere ed equilibrare',
  'Robot, creature e veicoli che si muovono davvero',
  'Leve, pulegge, ruote, assi, manovelle e meccanismi',
  'Sfide STEM per progettare, testare e risolvere',
  'Progetti passo-passo che portano alle invenzioni originali',
  '5 bonus esclusivi inclusi',
  'Accesso istantaneo · pagamento unico · accesso a vita',
]

export interface ValueItem {
  title: string
  detail: string
  value: string
}

export const valueStack: ValueItem[] = [
  {
    title: '6 Volumi con guide passo-passo',
    detail: 'Dalle fondamenta dell’inventore alle invenzioni originali',
    value: '€ 89',
  },
  {
    title: 'Guida ai Materiali Domestici',
    detail: 'Cosa conservare per partire subito',
    value: '€ 12',
  },
  {
    title: 'Costruzioni Rapide da 15 Minuti',
    detail: 'Missioni brevi per i giorni pieni',
    value: '€ 14',
  },
  {
    title: 'Guida per Genitori "Costruire Insieme"',
    detail: 'Aiutare senza sostituirsi al bambino',
    value: '€ 14',
  },
  {
    title: 'Missioni di Ingegneria all’Aperto',
    detail: 'Sfide da testare in giardino o al parco',
    value: '€ 12',
  },
  {
    title: 'Kit dei Traguardi e Template',
    detail: 'Schede tecniche e diplomi da stampare',
    value: '€ 8',
  },
]

export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Servono kit costosi?',
    answer:
      'No. Si usano cartone, tappi, cannucce, elastici e altri materiali di riciclo che hai già in casa. Ogni progetto elenca i materiali all’inizio.',
  },
  {
    question: 'Devo essere un ingegnere?',
    answer:
      'Assolutamente no. Le guide sono fatte per essere seguite da chiunque, anche senza alcuna esperienza tecnica precedente.',
  },
  {
    question: 'È un libro fisico?',
    answer:
      'È un sistema digitale in PDF con accesso immediato: puoi leggerlo su tablet, telefono o computer, oppure stampare solo il progetto del giorno.',
  },
  {
    question: 'Per quale età è pensato?',
    answer:
      'È ideale per bambini dai 5 ai 12 anni. I più piccoli costruiscono accanto a un adulto, i più grandi diventano autonomi già dal secondo volume.',
  },
  {
    question: 'Come ricevo l’accesso?',
    answer:
      'Subito dopo il pagamento ricevi via email il link per scaricare tutto. L’accesso è a vita e include gli aggiornamenti futuri.',
  },
  {
    question: 'È un abbonamento?',
    answer:
      'No. È un pagamento unico, senza rinnovi e senza nulla da disdire.',
  },
  {
    question: 'E se non fosse quello che mi aspettavo?',
    answer:
      'Hai 7 giorni per provarlo. Se non è quello che cercavi, scrivici e ti rimborsiamo l’intero importo senza domande scomode.',
  },
]
